export default __webpack_public_path__ + "static/media/8.47551207.jpg";